import { Form, InputNumber } from 'antd';

import { parseInputNumber } from 'app/utils/typing';

import styles from '../RoomDiscount.module.scss';
import {
  ROOM_DISCOUNT_OVER_MAX_MESSAGE,
  isRoomDiscountOverMax,
  maxRoomDiscountRule,
} from '../roomDiscountRules';

import { RevenueShare } from './RevenueShare';

type ConstantDiscountRowProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  defaultNightRoomDiscount?: number | null;
  isEnabled: boolean;
};

export const ConstantDiscountRow = ({
  currencyFormatter,
  formRoomPrice,
  defaultNightRoomDiscount,
  isEnabled,
}: ConstantDiscountRowProps) => (
  <div className={styles.discountRow}>
    <span>Apply a discount of</span>
    <div className={styles.discountRateInput}>
      <Form.Item
        noStyle
        name="defaultNightRoomDiscount"
        validateStatus={
          isEnabled &&
          (!defaultNightRoomDiscount ||
            isRoomDiscountOverMax(defaultNightRoomDiscount))
            ? 'error'
            : ''
        }
        rules={
          isEnabled
            ? [{ required: true, message: 'Required' }, maxRoomDiscountRule]
            : []
        }
      >
        <InputNumber
          min={0}
          max={100}
          addonAfter="%"
          parser={parseInputNumber}
          disabled={!isEnabled}
        />
      </Form.Item>
      {isEnabled &&
        (formRoomPrice === null ||
          formRoomPrice === undefined ||
          defaultNightRoomDiscount === null ||
          defaultNightRoomDiscount === undefined) && (
          <span className={styles.errorMessage}>
            {formRoomPrice === null || formRoomPrice === undefined
              ? 'Average BAR required to calculate revenue share'
              : 'Default discount required'}
          </span>
        )}
      {isEnabled && isRoomDiscountOverMax(defaultNightRoomDiscount) && (
        <span className={styles.errorMessage}>
          {ROOM_DISCOUNT_OVER_MAX_MESSAGE}
        </span>
      )}
      {formRoomPrice &&
        defaultNightRoomDiscount !== null &&
        defaultNightRoomDiscount !== undefined &&
        defaultNightRoomDiscount > 0 && (
          <div className={styles.pricePreview}>
            <span className={styles.description}>
              Estimated room revenue share =
            </span>{' '}
            <RevenueShare
              currencyFormatter={currencyFormatter}
              basePrice={formRoomPrice}
              discountPercent={defaultNightRoomDiscount}
            />
          </div>
        )}
    </div>
    <span>to all rooms within packages</span>
  </div>
);
